import React from 'react';

import ActionIconsShowcase from './ActionIconsShowcase';
import { actionIconsSet } from './constants';

const ActionIcons = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          actionIconsSet.map((group, i) => (
            <li key={`actionIcon-showcase-${i}`}>
              <ActionIconsShowcase {...group} />
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

export default ActionIcons;



// WEBPACK FOOTER //
// ./src/containers/elements/ActionIcons/ActionIcons.js